<div class="card mb-4">
    <div class="card-body">
        <div class="row">
            <div class="d-flex justify-content-between flex-row flex-wrap gap-3">
                <div class="d-flex">
                    <div class="card-title mb-0">
                        <h3>Property Data</h3>
                    </div>
                </div>
            </div>
            <div class="card-body ps-4" [class.placeholder-glow]="isLoading()">
                <div class="row mb-3">
                    <label class="col-lg-4 fw-semibold text-muted">Title</label>
                    <div class="col-lg-8">
                        @if (isLoading()) {
                        <span class="placeholder col-6"></span>
                        } @else {
                        @if (CommonChecks.isNullOrUndefinedOrEmptyOrWhitespace(property()?.title)) {
                        <span class="fs-6 fst-italic">None Provided</span>
                        } @else {
                        <span class="fs-6">{{property()?.title}}</span>
                        }
                        }
                    </div>
                </div>
                <div class="row mb-3">
                    <label class="col-lg-4 fw-semibold text-muted">Address</label>
                    <div class="col-lg-8 d-flex align-items-center">
                        @if (isLoading()) {
                        <span class="placeholder col-4 me-2"></span>
                        <span class="placeholder col-2"></span>
                        } @else {
                        <span class="fs-6 me-2"
                            [innerHTML]="property()?.addresses![0] | Address:AddressPipeSecondaryAddressFormat.NewLine | SafeHtml"></span>
                        }
                    </div>
                </div>
                <div class="row mb-3">
                    <label class="col-lg-4 fw-semibold text-muted">Lot Number</label>
                    <div class="col-lg-8">
                        @if (isLoading()) {
                        <span class="placeholder col-7"></span>
                        } @else {
                        <span class="fs-6">{{property()?.lotNumber}}</span>
                        }
                    </div>
                </div>
                <div class="row mb-3">
                    <label class="col-lg-4 fw-semibold text-muted">Country</label>
                    <div class="col-lg-8">
                        @if (isLoading()) {
                        <span class="placeholder col-5"></span>
                        } @else {
                        <span class="fs-6 text-gray-800">{{ 'United States'}}</span>
                        }
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>